import { render } from "./snackbar.html?vue&type=template&id=6821cd87&scoped=true&ts=true&external"
import script from "./snackbar.ts?vue&type=script&lang=ts&external"
export * from "./snackbar.ts?vue&type=script&lang=ts&external"

import "./snackbar.scss?vue&type=style&index=0&id=6821cd87&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6821cd87"]])

export default __exports__